import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { watermarkChoiceMessages } from '../choice/watermarkChoiceMessages';
import { useOpenWatermarkOffer } from '../useOpenWatermarkOffer';
import { useUpsellShown } from '../useUpsellShown';
import { useWatermarkSurface } from '../useWatermarkSurface';
import { watermarkTrialMessages as messages } from './watermarkTrialMessages';

export interface PillWatermark {
  /** The second line of the pill: the count of watermarked files. */
  line: string;
  /** "Remove the watermark". */
  action: string;
  /** Opens the offer (design b4), not the plans window. */
  open: () => void;
}

/**
 * The watermark line of the sidebar trial pill and the top-bar chip (design: trial-upsell b1). Null
 * with 0 watermarked files, on a paid plan and for the demo artist: the pill then keeps its old
 * line and opens the plans window. `kind` is the state of the pill (`useTrialStatus`); null: no pill.
 */
export function usePillWatermark(kind: 'running' | 'lastDay' | 'ended' | null): PillWatermark | null {
  const intl = useIntl();
  const { applies, summary } = useWatermarkSurface();
  const openOffer = useOpenWatermarkOffer();
  const open = useCallback(() => openOffer('pill'), [openOffer]);
  const shows = kind !== null && applies && summary.files > 0;
  useUpsellShown('pill', shows);
  if (!shows) {
    return null;
  }
  let message = messages.pillRunning;
  if (kind === 'lastDay') {
    message = messages.pillLastDay;
  } else if (kind === 'ended') {
    message = messages.pillFree;
  }
  return {
    line: intl.formatMessage(message, { count: summary.files }),
    action: intl.formatMessage(watermarkChoiceMessages.remove),
    open,
  };
}
